import React, { useState, useEffect } from "react";
import { Typography, Grid } from "@mui/material";
import TableData from "./columns";
import api from "_api";

const Bill = () => {
  const [companyData, setCompanyData] = useState([]);
  const [bankData, setBankData] = useState([]);
  const [bankHeader] = useState([
    { label: "#" },
    { label: "ธนาคาร" },
    { label: "เลขที่บัญชี" },
    { label: "ชื่อบัญชี" },
  ]);
  const [courierData, setCourierData] = useState([]);
  const [courierHeader] = useState([
    { label: "#" },
    { label: "ชื่อ-นามสกุล" },
    { label: "ตำแหน่ง" },
  ]);

  const fetchProductData = async () => {
    try {
      const { data: datas, isStatus: status } = await api.super_admin.getBill();
      console.log(datas);

      if (status) {
        let dataBank =
          datas.bank.length > 0
            ? datas.bank.map((item) => ({
                bank_name: item.bank_company,
                bank_number: item.bank_number,
                account: item.bank_name,
              }))
            : [];
        setBankData(dataBank);

        let dataCourier =
          datas.courier.length > 0
            ? datas.courier.map((item) => ({
                name: `${item.titlename} ${item.firstname} ${item.lastname}`,
                position: item.position,
              }))
            : [];
        setCourierData(dataCourier);

        let dataCompany =
          datas.company.length > 0
            ? datas.company.map((item) => [
                { label: "โลโก้", data: item.logo },
                {
                  label: "ชื่อบริษัท",
                  data: item.name,
                },
                { label: "Tax ID", data: item.tax_id },
                {
                  label: "ที่อยู่",
                  data: item.address,
                },
                { label: "เบอร์โทร", data: item.tel },
                { label: "Fax", data: item.fax },
              ])
            : [];
        setCompanyData(dataCompany[0]);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData();
  }, []);
  return (
    <div>
      <Grid
        item
        xs={12}
        sm={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography component="div" style={{ fontSize: "32px" }}>
          ข้อมูลสำหรับออกบิล
        </Typography>
      </Grid>
      <TableData
        headers={[{ label: "รายละเอียดบริษัท" }]}
        datas={companyData}
        isTable={false}
      />

      <Grid
        container
        spacing={5}
        style={{
          marginBottom: "16px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
          }}
        >
          <TableData title={"การชำระ"} headers={bankHeader} datas={bankData} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
          }}
        >
          <TableData
            title={"ผู้ส่งเอกสาร/ผู้ออกเอกสาร"}
            headers={courierHeader}
            datas={courierData}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default Bill;
